import { useState, useEffect } from "react"
import "98.css"
//import { hiscoresAPI } from './api/hiscores.js';

import ContactForm from './contactTest.js'
import Mothership from './mothership.js'
import Explorer from './explorer.js'
//import Files from './files.js'
//import Windows from './windows.js'
import Snake from './snake.js'
//import { data } from 'jquery'
import LoginScreen from './login.js'
import Terminal from './terminal.js'
import IncorrectPass from './incorrectPassword.js'
import Calendar from './calendar.js'
import RecentRelease from './recentrelease.js'
import Settings from './settings.js'
import { data } from "jquery"

export default function Home5() {

    useEffect(() => {
        clearActiveWindow();
        if (!getCookie('recentRelease')) {
            setRecentReleaseActive(true);
        }
        
        return () => {
            //console.log('Component will unmount');
        };
    }, []);

    const [openGame, setOpenGame] = useState(false);
    const [openMothership, setOpenMothership] = useState(false);
    const [startup, setStartup] = useState(false);
    const [openTerminal, setOpenTerminal] = useState(false);
    const [incorrectPass, setIncorrectPass] = useState(false);
    const [calendarActive, setCalendarActive] = useState(false);
    const [recentRelease, setRecentReleaseActive] = useState(false);
    const [settingsActive, setSettingsActive] = useState(false);

    var getCookie = function(n) {for(var t=n+"=",r=document.cookie.split(";"),e=0;e<r.length;e++){for(var g=r[e];" "==g.charAt(0);)g=g.substring(1,g.length);if(0==g.indexOf(t))return g.substring(t.length,g.length)}return null};
    
    function clearActiveWindow() {
        document.querySelectorAll('.window').forEach(window => {
            window.classList.remove('active');
        })
    }

    function closeStartMenu() {
        if (!document.querySelector('.start-menu-wrapper').classList.contains('hidden')){
            document.querySelector('.start-menu-wrapper').classList.add('hidden');
        }
    }

    window.addEventListener('click', function(e) {
        if (!e.target.closest('.start-menu-wrapper') && !e.target.classList.contains('start-button')) {
            // console.log(e.target)
            closeStartMenu();
        }
    });

    function showContactForm(e) {

        closeStartMenu();
        
        var el = e.target;
        if (!e.target) {
            el = e;
        }
        var dataName = el.getAttribute('data-name');
        //document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        clearActiveWindow();
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
        if (document.querySelector('.window[data-name="Contact Form"]').classList.contains('hidden')) {
            //var el = e.target;
            //console.log(el);
            checkTray(el);
            document.querySelector('.window[data-name="Contact Form"]').classList.remove('hidden');
        }
    }

    /*function showWindow(e) {
        var el = e.target;
        var dataName = el.getAttribute('data-name');
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        if (document.querySelector('.window[data-name="' + dataName +'"]').classList.contains('hidden')) {
            var el = e.target;
            //console.log(el);
            checkTray(el);
            document.querySelector('.window[data-name="' + dataName +'"]').classList.remove('hidden');
        }
    }*/

    /*function showMothership(e) {
        var el = e.target;
        var dataName = el.getAttribute('data-name');
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        generateMessage1('.window[data-name="The Mothership"] .message-header')
        if (document.querySelector('.window[data-name="The Mothership"]').classList.contains('hidden')) {
            var el = e.target;
            //console.log(el);
            checkTray(el);
            document.querySelector('.window[data-name="The Mothership"]').classList.remove('hidden');
        }
    }*/

    /*function showFiles(e) {
        var el = e.target;
        var dataName = el.getAttribute('data-name');
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        if (document.querySelector('.window[data-name="Files"]').classList.contains('hidden')) {
            var el = e.target;
            //console.log(el);
            checkTray(el);
            document.querySelector('.window[data-name="Files"]').classList.remove('hidden');
        }
    }*/

    function showExplorer(e) {

        closeStartMenu();

        var el = e.target;
        if (!e.target) {
            el = e;
        }
        // console.log(el)
        var dataName = el.getAttribute('data-name');
        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        clearActiveWindow();
        document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');
        checkTray(el);
        if (document.querySelector('.window[data-name="Explorer"]').classList.contains('hidden')) {
            //var el = e.target;
            //console.log(el);
            checkTray(el);
            document.querySelector('.window[data-name="Explorer"]').classList.remove('hidden');
        }
    }

    function showEvents(e) {
        clearActiveWindow();
        setCalendarActive(true);
        if (document.querySelector('.window[data-name="Events"]')) {
            document.querySelector('.window[data-name="Events"]').classList.add('active');
            document.querySelector('.window-container').append(document.querySelector('.window[data-name="Events"]'));
        }
    }

    /*function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }
    */

    function reOpen(selector) {
        
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        //console.log('HP')
        var dataName = selector.getAttribute('data-name');

        //document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
        clearActiveWindow();
        if (dataName) {
            document.querySelector('.window[data-name="' + dataName +'"]').classList.add('active');

            if (document.querySelector('.window[data-name="' + dataName + '"]')) {
                selector.ariaSelected = 'true';
                document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
                document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));
            }
        } else {
            if (selector.closest('.window').getAttribute('data-name') === "snake.exe") {
                document.querySelector('.window[data-name="snake.exe"]').classList.add('active');
                checkTray(document.querySelector('.window[data-name="snake.exe"]'))
            }
        }
    }

    function hideContactForm(e) {
        var el = e.target;
        //console.log(el);
        var dataName = el.getAttribute('data-name');
        checkTray(el, true);
        document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');

        if (dataName === 'snake.exe') {
            setOpenGame(false)
        }

        if (dataName === 'The Mothership') {
            setOpenMothership(false)
        }

        if (dataName === 'Terminal') {
            setOpenTerminal(false)
        }

        if (dataName === 'Events') {
            setCalendarActive(false)
        }

        if (dataName === 'Recent') {
            setRecentReleaseActive(false)
        }
        
        if (dataName === 'Settings') {
            setSettingsActive(false)
        }
    }

    function checkTray(selector, close=false) {
        var selector = selector;
        // console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.classList.add('toolbar-tab');
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    function generateMessage1(destination) {
        if (document.querySelector(destination).innerHTML === '') {

            var messageHeader = 'Welcome to The Mothership!'
            /*function lineBreak() {
                return '<br></br>';
            }*/
            //var messageContent = 'Hi friend, My name is Lenny.';

            typeWriteRun(messageHeader, '.window[data-name="The Mothership"] .message-header');
            {/*setTimeout(function() {
                typeWriteRun(messageContent, '.window[data-name="The Mothership"] .message-content');
            }, 1000);*/}

        }
    }

    function typeWriteRun(str, destination) {

        document.querySelector(destination).innerHTML = '';

        var i = 0;
        var txt = str
        var destination = destination;
        var speed = 25;

        function typeWriter() {
            if (i < txt.length) {
                document.querySelector(destination).innerHTML += txt.charAt(i);
                i++;
                setTimeout(typeWriter, speed);
            }
        }

        typeWriter()
    }

    function minimise(e) {
        var selector = e.target;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');
        //dataName = '[data-name="' + dataName + '"]';

        tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
        selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    }

    function loginPasswordCheck() {
        if (document.querySelector('#login-password').value === 'password') {
            setStartup(false);
        } else {
            document.querySelector('.window[data-name="Login"]').classList.add('disabled');
            setIncorrectPass(true);
        }
    }

    function closeIncorrectPass() {
        if (document.querySelector('.window[data-name="Login"]')) document.querySelector('.window[data-name="Login"]').classList.remove('disabled');
        if (document.querySelector('.window[data-name="Login"] input#login-password')) document.querySelector('.window[data-name="Login"] input#login-password').value = '';
        setIncorrectPass(false);
    }
    
    let renderSnake, renderMotherShip, renderStartup, renderIncorrectPass, renderTerminal, renderCalendar, renderRecentRelease, renderSettings;
    if (openGame) {
        clearActiveWindow();
        // renderSnake = <Snake hiscore={snakeTopScore} onMinimise={minimise} onClose={hideContactForm}/>
        renderSnake = <Snake onMinimise={minimise} onClose={hideContactForm} onReOpen={reOpen}/>
        checkTray(document.querySelector('[data-name="snake.exe"]'));
        if (document.querySelector('.window[data-name="snake.exe"]')) document.querySelector('.window[data-name="snake.exe"]').classList.add('active');
    }
    if (openMothership) {
        renderMotherShip = <Mothership onClose={hideContactForm}/>
        checkTray(document.querySelector('.desktop-icon.my-computer'));
    }
    if (startup) {
        renderStartup = <LoginScreen onClose={loginPasswordCheck}/>
    }
    if (incorrectPass) {
        renderIncorrectPass = <IncorrectPass onClose={closeIncorrectPass}/>
    }
    if (openTerminal) {
        renderTerminal = <Terminal onClose={hideContactForm}/>
        checkTray(document.querySelector('.start-menu-item[data-name="Terminal"]'));
    }
    if (calendarActive) {
        renderCalendar = <Calendar onClose={hideContactForm}/>
        checkTray(document.querySelector('.desktop-icon[data-name="Events"]'));
    }

    if (settingsActive) {
        renderSettings = <Settings onClose={hideContactForm}/>
        //checkTray(document.querySelector('.start-menu-item[data-name="Settings"]'));
    }
    
    if (recentRelease) {
        renderRecentRelease = <RecentRelease onClose={hideContactForm}/>
        checkTray(document.querySelector('.start-menu-item[data-name="Recent"]'));
    }

    function startMenuToggle() {
        document.querySelector('.start-menu-wrapper').classList.toggle('hidden');
    }

    function startItemClick(e) {
        var el = e.target.closest('.start-menu-item');
        // console.log(el);
        if (el.getAttribute('data-name') === 'Explorer') {
            showExplorer(el);
        }
        if (el.getAttribute('data-name') === 'Shut Down') {
            if (document.querySelector('.window[data-name="The Mothership"]')) {
                document.querySelector('.window[data-name="The Mothership"] button.form-close').click();
            }
            if (document.querySelector('.window[data-name="snake.exe"]')) {
                document.querySelector('.window[data-name="snake.exe"] button.form-close').click();
            }
            if (document.querySelector('.window[data-name="Terminal')) {
                document.querySelector('.window[data-name="Terminal"] button.form-close').click();
            }
            if (document.querySelector('.window[data-name="Explorer"]:not(.hidden)')) {
                document.querySelector('.window[data-name="Explorer"] button.form-close').click();
            }

            setStartup(true);
        }
        if (el.getAttribute('data-name') === 'Terminal') {
            clearActiveWindow();
            setOpenTerminal(true);
            if (document.querySelector('.window[data-name="Terminal"]')) document.querySelector('.window[data-name="Terminal"]').classList.add('active');
        }
        if (el.getAttribute('data-name') === 'Recent') {
            clearActiveWindow();
            setRecentReleaseActive(true);
            if (document.querySelector('.window[data-name="Recent"]')) document.querySelector('.window[data-name="Recent"]').classList.add('active');
        }
        if (el.getAttribute('data-name') === 'Settings') {
            clearActiveWindow();
            setSettingsActive(true);
            if (document.querySelector('.window[data-name="Settings"]')) document.querySelector('.window[data-name="Recent"]').classList.add('s');
        }
        document.querySelector('.start-menu-wrapper').classList.add('hidden');
    }

    function startSubItemClick(e) {
        var el = e.target.closest('li');
        if (el.getAttribute('data-name') === 'snake.exe') {
            setOpenGame(true)
        }
        if (el.getAttribute('data-name') === 'Contact Form') {
            showContactForm(el);
        }
        document.querySelector('.start-menu-wrapper').classList.add('hidden');
    }

    function openSnake() {
        clearActiveWindow();
        setOpenGame(true);
        if (document.querySelector('.window[data-name="snake.exe"]')) document.querySelector('.window[data-name="snake.exe"]').classList.add('active');
    }

    return (
        
        <>

        {renderStartup}
        {renderIncorrectPass}
        <div id="desktop" className="sexy-theme">


            <div className="logo-hp">
                <img src="/images/beluckylogo.png" alt="logo"/>
            </div>
            <div className="window-container">

                <ContactForm />
                {renderMotherShip}
                {/* <Mothership /> */}
                {/*<Files />*/}
                <Explorer openSnake={openSnake} openContactForm={showContactForm}/>
                {/*<Snake hiscore={snakeTopScore} />*/}
                {renderSnake}
                {renderTerminal}
                {renderCalendar}
                {renderRecentRelease}
                {renderSettings}

            </div>

            {/*<div className="desktop-icon my-computer" title="The Mothership" onClick={() => setOpenGame(true)} data-name="The Mothership">The Mothership</div>*/}

            <div className="desktop-icons">
                {/*<div className="desktop-icon my-computer" title="The Mothership" onClick={() => setOpenMothership(true)} data-name="The Mothership">The Mothership</div>*/}
                {/*<div className="desktop-icon my-documents" title="Files" onClick={showFiles} data-name="Files">Files</div>*/}             
                <div className="desktop-icon network" title="The Drive" onClick={showExplorer} data-name="Explorer">The Drive</div>
                <a href="https://open.spotify.com/artist/0COjQBYwITpwsJ7KVbQUbu" target="_blank" rel="noreferrer" className="desktop-icon spotify link" title="Music" data-name="Music">Tunes</a>
                <a href="https://www.instagram.com/beluckyband/" target="_blank" rel="noreferrer" className="desktop-icon ig link" title="Instagram" data-name="Socials">Socials</a>
                <a href="https://linktr.ee/beluckyband" target="_blank" rel="noreferrer" className="desktop-icon lt link" title="Linktree" data-name="Linktree">Linktree</a>
                {/* <div className="desktop-icon snake" title="Snake" data-name="snake.exe" onClick={() => setOpenGame(true)}>Snake 2</div> */}
                <div className="desktop-icon events" title="Events" onClick={showEvents} data-name="Events">Events</div>
                <div className="desktop-icon trash-empty" title="Recycle Bin">Trash</div>
            </div>

            <div id="toolbar">
                <div className="toolbar-start-menu">
                    <button className="start-button" onClick={startMenuToggle}>
                        START
                    </button>
                
                    <div className="start-menu-wrapper hidden">
                        <div className="start-menu-title">
                            <span><strong>BE</strong>LUCKY</span>
                        </div>
                        
                        <div className="start-menu">
                            
                            {/* <div className="start-menu-item" data-name="Pinned">
                                <div className="start-menu-item-icon"><img src="/images/social_logos_cropped/note-2.png"/></div>
                                <div className="start-menu-item-title">Pinned</div>
                            </div> */}

                            <div className="start-menu-item recent" onClick={startItemClick} data-name="Recent">
                                <div className="start-menu-item-icon">
                                    <img src="/images/social_logos_cropped/warning.png" alt="alert-icon"/>
                                </div>
                                <div className="start-menu-item-title">Latest Release</div>
                            </div>

                            <div className="start-menu-item" data-name="Programs">
                                <div className="start-menu-item-icon">
                                    <img src="/images/social_logos_cropped/program.png" alt="program icon"/>
                                </div>
                                <div className="start-menu-item-title">Programs</div>
                                <ul className="start-menu-level-1" data-name="Programs">
                                    <li onClick={startSubItemClick}>
                                        <a href="https://open.spotify.com/artist/0COjQBYwITpwsJ7KVbQUbu" target="_blank" rel="noreferrer" className="spotify link">
                                            <div className="start-menu-level-1-icon">
                                                <img src="/images/social_logos_cropped/spotify.png" alt="spotify icon"/>
                                                </div>
                                            <div className="">Spotify</div>
                                        </a>
                                    </li>
                                    <li onClick={startSubItemClick}>
                                        <a href="https://www.instagram.com/beluckyband/" target="_blank" rel="noreferrer" className="ig link">
                                            <div className="start-menu-level-1-icon">
                                                <img src="/images/social_logos_cropped/instagram2.png" alt="instagram icon"/>
                                            </div>
                                            <div className="">Instagram</div>
                                        </a>
                                    </li>
                                    <li onClick={startSubItemClick}>
                                        <a href="https://www.google.com/search?q=beluckyband" target="_blank" rel="noreferrer" className="ie">
                                            <div className="start-menu-level-1-icon">
                                                <img src="/images/social_logos_cropped/internet2.png" alt="internet icon"/>
                                            </div>
                                            <div className="">Internet Explorer</div>
                                        </a>
                                    </li >                                  
                                    <li onClick={startSubItemClick} data-name="Contact Form">
                                        <div className="start-menu-level-1-icon">
                                            <img src="/images/social_logos_cropped/outlook.png" alt="outlook icon"/>
                                        </div>
                                        <div className="">Outlook Express</div>
                                    </li>
                                    <li onClick={startSubItemClick} data-name="snake.exe">
                                        <div className="start-menu-level-1-icon">
                                            <img src="/images/snake-game2.png" alt="snake 2 game icon"/>
                                        </div>
                                        <div className="">Snake 2</div>
                                    </li>
                                </ul>
                            </div>
                            {/* <div className="start-menu-item" data-name="Favourites">
                                <div className="start-menu-item-icon"><img src="/images/social_logos_cropped/favs.png"/></div>
                                <div className="start-menu-item-title">Favorites</div>
                            </div> */}
                            {/* <div className="start-menu-item" data-name="The Mothership">
                                <div className="start-menu-item-icon"><img src="/images/social_logos_cropped/internet.png"/></div>
                                <div className="start-menu-item-title">The Mothership</div>
                            </div> */}
                            <div className="start-menu-item" onClick={startItemClick} data-name="Explorer">
                                <div className="start-menu-item-icon">
                                    <img src="/images/social_logos_cropped/computer.png" alt="computer icon"/>
                                </div>
                                <div className="start-menu-item-title">The Drive</div>
                            </div>
                            <a href="https://linktr.ee/beluckyband" target="_blank" rel="noreferrer" onClick={startItemClick} className="start-menu-item" data-name="Linktree">
                                <div className="start-menu-item-icon">
                                    <img src="/images/social_logos_cropped/tree.png" alt="tree icon"/>
                                </div>
                                <div className="start-menu-item-title">Linktree</div>
                            </a>
                            {/* <div className="start-menu-item" onClick={startItemClick} data-name="Settings">
                                <div  className="start-menu-item-icon"><img src="/images/social_logos_cropped/settings.png"/></div>
                                <div className="start-menu-item-title">Settings</div>
                            </div> */}
                            {/* 
                            <div className="start-menu-item" onClick={startItemClick} data-name="Help">
                                <div className="start-menu-item-icon"><img src="/images/social_logos_cropped/help.png"/></div>
                                <div className="start-menu-item-title">Help</div>
                            </div> */}
                            {/* <div className="start-menu-item recent" onClick={startItemClick} data-name="Terminal">
                                <div className="start-menu-item-icon">
                                    <img src="/images/social_logos_cropped/command.png" alt="command prompt icon"/>
                                    </div>
                                <div className="start-menu-item-title">Run</div>
                            </div> */}
                            {/* <div className="start-menu-item" onClick={startItemClick} data-name="Account">
                                <div className="start-menu-item-icon"><img src="/images/social_logos_cropped/account2.png"/></div>
                                <div className="start-menu-item-title">Account</div>
                            </div> */}
                            <div className="start-menu-item" onClick={startItemClick} data-name="Shut Down">
                                <div className="start-menu-item-icon">
                                    <img src="/images/social_logos_cropped/shutdown.png" alt="shut down computer icon"/>
                                </div>
                                <div className="start-menu-item-title">Shut Down</div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div className="toolbar-separator">
                    <div className="toolbar-separator"></div>
                </div>
                
                <div className="toolbar-left">
                    <a href="https://www.google.com/search?q=beluckyband" target="_blank" rel="noreferrer" className="toolbar-icon ie"></a>
                    <div className="toolbar-icon outlook" onClick={showContactForm} data-name="Contact Form"></div>
                </div>
                
                <div className="toolbar-separator"></div>

                <div className="toolbar-tabs">
                    <div className="tray">
                        <menu role="tablist">
                            {/*<li role="tab" aria-selected="true" data-name="Contact Form"><a href="#tabs">Contact Form</a></li>*/}
                        </menu>
                    </div>
                </div>
            </div>
        </div>

        </> 
    )
}